<div class="empty">
  <mat-icon fontSet="material-icons-round">{{ icon }}</mat-icon>
  <h4 *ngIf="heading">{{ heading | transloco }}</h4>
  <p *ngIf="message">{{ message | transloco }}</p>
  <ng-content></ng-content>
</div>
